<div class="text-container">
  <div
    #textContainer
    class="truncatable-content"
    [class.expanded]="isExpanded"
    [innerHTML]="text"
    style="
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      line-height: 1.7;
    "
    [style.-webkit-line-clamp]="!isExpanded ? maxLines : null"
    [style.max-height]="!isExpanded ? lineHeight * maxLines + 'px' : 'none'"
  ></div>

  <button
    *ngIf="needsTruncation"
    (click)="toggleExpand()"
    class="toggle-button"
  >
    {{
      !isExpanded
        ? ("base.mostra_btn" | translate)
        : ("base.nascondi_btn" | translate)
    }}
  </button>
</div>
